import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { GLOBAL } from "./global";

@Injectable({
  providedIn: "root"
})
export class ExcepcionService {
  public url: string;

  constructor(public _http: HttpClient) {
    this.url = GLOBAL.url;
  }

  getExcepcionesPorEmpresa(token, empresa_id, anio_id): Observable<any> {
    let headers = new HttpHeaders()
      .set("Content-Type", "application/x-www-form-urlencoded")
      .set("Authorization", token);
    return this._http.get(
      this.url + "exceptionsByEmpresa/" + empresa_id + "/" + anio_id,
      { headers: headers }
    );
  }

  doExcepcion(token, info): Observable<any> {
    let json = encodeURIComponent(JSON.stringify(info));
    let params = "json=" + json;

    let headers = new HttpHeaders()
      .set("Content-Type", "application/x-www-form-urlencoded")
      .set("Authorization", token);
    // Url del back
    return this._http.post(this.url + "excepciones", params, {
      headers: headers
    });
  }
}
